// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import '../pages/Home.css';

function Home() {
  usePageTitle('Home');

  return (
    <div className="home-container">
      <header className="home-header">
        <div className="logo">Agent Book CRM</div>
        <nav className="home-nav">
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <a href="#contact">Contact</a>
          <Link to="/login" className="login-btn">Login</Link>
        </nav>
      </header>

      <section className="hero-section">
        <h1>CRM Built for Insurance Agents</h1>
        <p>Streamline your workflow, track policies, and grow your business with ease.</p>
        <a href="/signup" className="cta-button">Get Started</a>
      </section>

      <footer className="home-footer">
        <p>&copy; {new Date().getFullYear()} Agent Book CRM. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;